// export const baseUrl = "ws://127.0.0.1:8000"
export const baseUrl = "wss://bsh.api-boyahane.smartopt.com.tr"


// export const apiUrl = "http://127.0.0.1:8000"
export const apiUrl = "https://bsh.api-boyahane.smartopt.com.tr"